import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { findDuplicateAccountGroups } from '../utils';

import { ACCOUNT_GROUPS } from 'RestAPIs/endpoints';
import { useCreateResource } from 'RestAPIs/useCreateResource';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { ControlledTextField } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { AccountGroupData } from '../../../../Procedures/Reports/type';
import schema from './schema';

const CreateAccountGroupForm: React.FC<
  FormComponentProps & { accountGroups: AccountGroupData[] | undefined }
> = ({ handleClose, rowData, accountGroups }) => {
  const { t } = useTranslation('common');
  const { mutate, isLoading } = useCreateResource({
    url: ACCOUNT_GROUPS,
    invalidateQueryKey: ['account-groups']
  });

  const methods = useForm({
    defaultValues: schema.cast(rowData),
    resolver: yupResolver(schema)
  });

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    if (findDuplicateAccountGroups(data, accountGroups) !== -1) {
      return methods.setError('name', {
        type: 'unique violation',
        message: 'Unique violation'
      });
    }

    mutate(data);
    handleClose();
  };

  return (
    <>
      <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
        <MultiStepForm.Section title={t('adminPortal.baseSelection')}>
          <ControlledTextField
            control={methods.control}
            name="name"
            label={t('name')}
          />
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <Box display="flex" ml="auto">
            <LoadingButton
              loading={isLoading}
              type="submit"
              variant="contained"
              autoFocus
              color="primary"
            >
              {t('save')}
            </LoadingButton>
          </Box>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </>
  );
};

export default CreateAccountGroupForm;
